const ImportRequestTypes = {
  QUICK: "QuickRequest",
  QUOTE: "Shipment",
  TRACKING: "Tracking",
};

export default ImportRequestTypes;
